import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import CustomHeading from "../../common/CustomHeading";
import CustomButton from "../../common/CustomButton";

import BulkUploadModal from "./BulkUploadModal";

import useOutsideClick from "../../../hooks/useOutsideClick";
import { ToastContainer } from "react-toastify";
import { Divider, getIcons, MenuItem } from "../../Constant/Constant";

import useInterestAndSource from "../../../hooks/useInterstAndSource";
import InterestTags from "./InterestTags";
import Leadsource from "./Leadsource";
import InterestLocation from "./InterestLocation";

const InterestAndSourceMain = () => {
  const {
    interestLocationData,
    sourceData,
    interestTagData,
    loading,

    menuOpen,
    setMenuOpen,
    isModalOpen,
    modalHeading,
    selectedFile,

    tagLimits,
    counts,
    limitsExceeded,

    dropdownRef,

    toggleMenu,
    openModal,
    closeModal,

    fetchInterestLocationData,
    fetchSourceData,
    fetchInterestTagData,

    createInterestLocation,
    createSource,
    createInterestTag,
    updateInterestLocation,
    updateSource,
    updateInterestTag,

    handleFileChange,
    handleBulkUpload,
    handleDownloadTemplate,
    insertedCount,
    skippedUnitsInfo,
    showSkippedModal,
    setShowSkippedModal
  } = useInterestAndSource();

  const icons = getIcons();

  useOutsideClick(dropdownRef, () => setMenuOpen(false));
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    fetchInterestLocationData();
    fetchSourceData();
    fetchInterestTagData();
  }, []);

  const tabs = ["Lead Source", "Interest Tags",  "Locations"];

  const handleItemClick = (heading) => {
    openModal(heading);
  };

  return (
    <>
      <div className="bg-appGrayBackground h-screen">
        <AdminAppBar />
        <ToastContainer />

        <div className="bg-appGrayBackground mt-20 pt-4 px-6 pb-12">
          <div className="flex justify-between mt-4 px-2">
            <CustomHeading title={`Tags`} isIcon={true} />
          </div>

          <div className="flex items-center justify-between">
            <div className="bg-white relative flex justify-between rounded-[12px]  mt-[30px] w-fit px-10 gap-16 ">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`py-3  px-4 text-base  relative font-medium focus:outline-none ${
                    activeTab === index
                      ? "border-b-4   border-customGreen text-customGreen"
                      : "text-gray-500 hover:text-bcustomGreen"
                  }`}
                  onClick={() => {
                    setActiveTab(index);
                  }}
                >
                  {tab}
                  <div className="bg-customGreen absolute bottom-0 h-2 rounded-md"></div>
                </button>
              ))}
            </div>

            {activeTab !== 0 && (
              <div
                className="relative inline-block text-left"
                ref={dropdownRef}
              >
                <CustomButton
                  label={"Bulk Import"}
                  className="bg-customGreen rounded-md p-1 px-5 w-fit text-lg text-white h-10 text-center"
                  onClick={() =>
                    handleItemClick(
                      activeTab === 1 ? "Interest Tags" : "Location"
                    )
                  }
                />

                {menuOpen && (
                  <div className="absolute right-0 mt-4 w-64 bg-white rounded-xl shadow-lg z-10">
                    <div className="absolute -top-2 rounded right-4 w-4 h-4 bg-white rotate-45"></div>

                    <div className="py-2">
                      <MenuItem
                        onClick={() => handleItemClick("Interest Tags")}
                        icon={icons.interstTagIcon}
                        label="Interest Tags"
                        disabled={limitsExceeded.interestTag}
                        className={
                          limitsExceeded.interestTag
                            ? "opacity-50 cursor-not-allowed"
                            : "cursor-pointer"
                        }
                      />
                      <Divider />
                      {/* 
                      <MenuItem
                        onClick={() => handleItemClick("Lead Sources")}
                        icon={icons.interestSourceIcon}
                        label="Lead Source"
                        disabled={limitsExceeded.leadSource}
                        className={
                          limitsExceeded.leadSource
                            ? "opacity-50 cursor-not-allowed"
                            : "cursor-pointer"
                        }
                      />
                      <Divider /> */}

                      <MenuItem
                        onClick={() => handleItemClick("Location")}
                        icon={icons.interestLocationIcon}
                        label="Location"
                        disabled={limitsExceeded.location}
                        className={
                          limitsExceeded.location
                            ? "opacity-50 cursor-not-allowed"
                            : "cursor-pointer"
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="flex flex-col mt-7 gap-9 bg-white rounded-md shadow-md p-6">
            {/* Lead Source Section */}

            {activeTab === 0 && (
              <Leadsource
                handleItemClick={handleItemClick}
                toggleMenu={toggleMenu}
                leadSources={sourceData}
                dropdownRef={dropdownRef}
                menuOpen={menuOpen}
                onCreate={createSource}
                onUpdate={updateSource}
                maxSources={tagLimits.leadSource}
                disableInput={counts.leadSource >= tagLimits.leadSource}
                loading={loading}
              />
            )}
            {/* Interest Tags Section */}
            {activeTab === 1 && (
              <InterestTags
                tags={interestTagData}
                onCreate={createInterestTag}
                onUpdate={updateInterestTag}
                maxTags={tagLimits.interestTag}
                disableInput={counts.interestTag >= tagLimits.interestTag}
                loading={loading}
              />
            )}

            {/* Location Section */}

            {activeTab === 2 && (
              <InterestLocation
                locations={interestLocationData}
                onCreate={createInterestLocation}
                onUpdate={updateInterestLocation}
                maxLocations={tagLimits.location}
                disableInput={counts.location >= tagLimits.location}
                loading={loading}
              />
            )}
          </div>
        </div>
      </div>

      <BulkUploadModal
        isOpen={isModalOpen}
        onClose={closeModal}
        modalHeading={modalHeading}
        selectedFile={selectedFile}
        onFileChange={handleFileChange}
        onUpload={handleBulkUpload}
        onDownloadTemplate={handleDownloadTemplate}
        currentCount={
          modalHeading === "Interest Tags"
            ? counts.interestTag
            : modalHeading === "Lead Sources"
            ? counts.leadSource
            : modalHeading === "Location"
            ? counts.location
            : 0
        }
        maxCount={
          modalHeading === "Interest Tags"
            ? tagLimits.interestTag
            : modalHeading === "Lead Sources"
            ? tagLimits.leadSource
            : modalHeading === "Location"
            ? tagLimits.location
            : 0
        }
      />

{showSkippedModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white p-4 rounded-xl shadow-xl w-full max-w-md overflow-hidden">
      {/* Header */}

      <div className="flex bg-slate-100 p-2 rounded-md justify-between items-center mb-6">
          <h2
            id="bulk-upload-title"
            className="text-lg font-medium text-green-700"
          >
            Duplicate Units Found
          </h2>
          <button
             onClick={() => setShowSkippedModal(false)}
            className="text-red-600 bg-white  focus:outline-none rounded-full p-2"
            aria-label="Close modal"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

      {/* Content */}
      <div className="">
        {/* Summary Cards */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="bg-green-5 border text-center border-green-100 rounded-lg p-3">
            <div className="text-green-800 font-medium text-sm">Successful</div>
            <div className="text-2xl font-bold text-green-600">{insertedCount}</div>
            <div className="text-green-500 text-xs">units inserted</div>
          </div>
          <div className="bg-yellow-0 border text-center border-yellow-100 rounded-lg p-3">
            <div className="text-yellow-800 font-medium text-sm">Skipped</div>
            <div className="text-2xl font-bold text-yellow-600">{skippedUnitsInfo.skippedCount}</div>
            <div className="text-yellow-500 text-xs">duplicate units</div>
          </div>
        </div>

        {/* Skipped Units List */}
        <div className="mb-4">
          <h3 className="text-sm font-medium text-gray-700 mb-2 flex items-center">
            <svg className="w-4 h-4 mr-1 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            Duplicate units found:
          </h3>
          
          <div className="border border-gray-200 rounded-lg overflow-hidden">
            <div className="max-h-48 overflow-y-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Unit No.
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {skippedUnitsInfo.skippedUnitNos.map((unitNo, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
                        {unitNo}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end pt-4 border-t border-gray-200">
          <button
            onClick={() => {
              setShowSkippedModal(false)
             
            }}
            className="px-6 py-2 bg-customGreen text-white rounded-lg  transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
          >
            Done 
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </>
  );
};

export default InterestAndSourceMain;
